import "./styles/index.less";
import { Space } from 'antd';
import cx from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DivisionLine = function DivisionLine(_ref) {
  var lineClassName = _ref.lineClassName,
      children = _ref.children,
      gap = _ref.gap,
      divisionCom = _ref.divisionCom;

  var countChildren = function countChildren() {
    var childFilter = [];
    React.Children.forEach(children, function (Child) {
      if (Child !== null) {
        childFilter.push(Child);
      }
    });
    return childFilter;
  };

  var childrenFilter = countChildren();

  var divisionComponent = divisionCom || /*#__PURE__*/_jsx("div", {
    className: cx('dr-division-line', lineClassName),
    style: {
      margin: gap ? "0 ".concat(gap, "px") : '0 20px'
    }
  });

  return /*#__PURE__*/_jsx("div", {
    className: "dr-division",
    children: /*#__PURE__*/_jsx(Space, {
      size: 0,
      children: childrenFilter && React.Children.map(childrenFilter, function (Child, index) {
        return /*#__PURE__*/_jsxs(Space, {
          size: 0,
          children: [Child, index !== childrenFilter.length - 1 && divisionComponent]
        }, Math.random());
      })
    })
  });
};

export default DivisionLine;